import request from "@/utils/request";

export function getHeaders(key) {
  return request({
    url: `/auth/get_headers?key=${key}`,
    method: "get",
  });
}
